import React from 'react';
import _ from 'lodash';
import styles from './css/MainService.styl';
import {
  formatPhoneNumber,
  formatAddress,
  formatPhrase,
} from '../../../../../appModules/utilities/formatHelpers';
import {isFuneralHomePageType} from '../../../../../reactModules/shared/utilities/personPageType';
import {buildUrl, getMapUrl} from '../../../../shared/utilities/urlHelpers';
import imageChecker from '../../../../shared/utilities/imageChecker';
import {FlowerIcon} from '../../../../shared/Svgs';
import {bindMethods} from '../../../../shared/utilities/componentHelpers';
import appConfig from '../../../../../appConfig/AppConfig';

const conf = appConfig();

/**
 *  MainServices Module
 * @class   MainService
 */
export class MainService extends React.Component {
  static propTypes = {
    flowerClickEvents: React.PropTypes.func,
    flowersLink: React.PropTypes.string,
    personPageType: React.PropTypes.string,
    serviceGroup: React.PropTypes.object,
    showFlowers: React.PropTypes.bool,
  };

  /**
   * Constructor
   * @param  {Object}     props props object
   * @return {Undefined}  Returns nothing
   */
  constructor(props) {
    super(props);

    const {serviceGroup: {funeralHomes} = {}} = this.props;
    const [primaryFuneralHome = {}] = funeralHomes || [];
    const {logo: funeralHomeLogo} = primaryFuneralHome;

    if (funeralHomeLogo) {
      this.funeralHomeLogo =
        funeralHomeLogo === '/legacy/images/fhlogo/logo.gif'
          ? null
          : `${buildUrl(conf.environmentalUrl.cacheUrl, funeralHomeLogo)}`;
    }

    this.state = {image: this.funeralHomeLogo};

    bindMethods(this, ['handleWindowLoad']);
  }

  /**
   * Lifecycle
   * @returns {Undefined} Returns nothing
   */
  componentDidMount() {
    window.addEventListener('load', this.handleWindowLoad);
  }

  /**
   * Lifecycle
   * @returns {Undefined} Returns nothing
   */
  componentWillUnmount() {
    window.removeEventListener('load', this.handleWindowLoad);
  }

  /**
   * Handles when window is loaded and fires a check on the logo image
   * @return {Undefined} Returns nothing
   */
  handleWindowLoad() {
    if (this.funeralHomeLogo) {
      if (!imageChecker(this.funeralHomeLogo)) {
        this.funeralHomeLogo = null;
        this.setState({image: false});
      }
    }
  }

  /**
   * Renders Component
   * @return {JSX} Rendered PersonHero Component
   */
  render() {
    const {
      flowerClickEvents,
      flowersLink,
      personPageType,
      serviceGroup,
      showFlowers,
    } = this.props;
    const {church, funeralHomes} = serviceGroup || {};
    const [primaryFuneralHome] = funeralHomes || [];
    const funeralHomePhone =
      primaryFuneralHome &&
      primaryFuneralHome.premiumSubscriber &&
      !_.isEmpty(_.trim(primaryFuneralHome.phone))
        ? formatPhoneNumber(primaryFuneralHome.phone)
        : null;
    const dataSet = primaryFuneralHome || church;
    let address = _.pick(dataSet, [
      'address',
      'address1',
      'address2',
      'city',
      'country',
      'postalCode',
      'state',
    ]);

    address.city = formatPhrase(address.city);
    address = formatAddress(address);

    const googleAddressLink = getMapUrl(address);
    const link = _.get(dataSet, 'directoryUrl') || googleAddressLink;

    return _.isEmpty(dataSet) ? null : (
      <aside className={styles.MainService}>
        {isFuneralHomePageType(personPageType) && this.funeralHomeLogo ? (
          <div>
            <a className={styles.sourceLogo} href={link} target="_blank">
              <figure>
                <img alt="Funeral Home Logo" src={this.funeralHomeLogo} />
              </figure>
            </a>
          </div>
        ) : null}
        <a className={styles.sourceName} href={link} target="_blank">
          {_.get(dataSet, 'name', '')}
        </a>
        <a
          className={styles.sourceAddress}
          href={googleAddressLink}
          target="_blank"
        >
          {address}
        </a>
        {funeralHomePhone ? (
          <a
            className={styles.sourcePhone}
            href={`tel:${funeralHomePhone.replace(/[()\- ]/g, '')}`}
          >
            {funeralHomePhone}
          </a>
        ) : null}
        {flowersLink && showFlowers ? (
          <a
            className={styles.flowersLink}
            data-ga-no-auto-tag
            href={flowersLink}
            onClick={flowerClickEvents}
            target="_blank"
          >
            <span>
              <FlowerIcon />
            </span>
            Send Flowers &rsaquo;
          </a>
        ) : null}
        {primaryFuneralHome &&
        primaryFuneralHome.premiumSubscriber &&
        primaryFuneralHome.directoryUrl ? (
          <div className={styles.prePlanningPanel}>
            <a
              className={styles.sourcePhone}
              style={{fontWeight: '600'}}
              href={link}
            >
              Learn about funeral pre-planning &rsaquo;
            </a>
          </div>
        ) : null}
      </aside>
    );
  }
}

export default MainService;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/MainService/MainService.js